export default __webpack_public_path__ + "static/media/ic_tempo_block.43ae64d3.svg";